import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { NotificationService } from '../../../common/notification.service/notification.service';

import { AuthService } from '../../../services/auth.service';

import * as _ from 'underscore';
import { OrganizationModel } from '../../organization/model/organization.model';
import { OrganizationService } from '../../organization/organization.service';
import { View } from '../../../common/model/view';
import { Severity } from '../../../common/notification.service/notification.model';
import { DashboardItemColumn, DashboardItemDescriptor, DashboardItemFilter, DashboardItemFilterType } from '../model/dashboard.item';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-dashboard-kpi',
  styleUrls: ['./kpi.component.sass'],
  templateUrl: './kpi.component.pug'
})
export class DashboardKpiComponent implements OnInit {
  @Input() item: DashboardItemDescriptor;
  @Input() config: any;

  organizations: OrganizationModel[] = [];
  organizationId: string;

  sortColumn: string = undefined;
  sortDirection: string = undefined;
  json: string = undefined;

  constructor(
    private bffService: DashboardService,
    private orgService: OrganizationService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
  }

  public async ngOnInit(): Promise<void> {
    this.config = this.config || {};
    this.config[this.item.id] = this.config[this.item.id] || {};

    this.json = this.item.json;

    const orgFilter = this.item.filters.find(f => f.type == DashboardItemFilterType.Organization);
    if (orgFilter) {
      const v = new View();
      v.addFilter('Deleted', 'false');
      this.orgService.getOrganizations(v).then(result => {
        this.organizations = result.value;

        this.item.filters.forEach(f => {
          if (f.type == DashboardItemFilterType.Organization)
          {
            let org = this.organizations.find(org => org.id == this.config[this.item.id][f.field]);
            if (!org && this.organizations.length > 0) org = this.organizations[0];

            if (org) {
              f.value = this.config[this.item.id][f.field];
              this.selectOrganization(f);
            }
          }
        });
      });
    }

    if (!this.item.filters.length) {
      await this.loadData();
    }
  }

  async selectOrganization(filter: DashboardItemFilter) {
    const org = this.organizations.find(o => o.id == filter.value);
    filter.textValue = org.mekhCode + ' - ' + org.name;
    this.config[this.item.id][filter.field] = filter.value;
    await this.loadData();
    await this.sort();
  }

  async selectGeneric(filter: DashboardItemFilter) {
    filter.textValue = filter.value;
    this.config[this.item.id][filter.field] = filter.value;
    await this.loadData();
    await this.sort();
  }

  async refresh() {
    await this.loadData();
    await this.sort();
  }

  async loadData() {
    if (this.item.filters.every(f => !!f.value)) {
      this.json = await this.bffService.getDashboardItemData(this.item.id, this.item.filters.map(f => f.value));
      
      if (this.json) {
        this.item.data = JSON.parse(this.json);
      }
    }
  }

  async sort(column: DashboardItemColumn = undefined): Promise<void> {
    if (column) {
      if (this.sortColumn == column.field) {
        this.sortDirection = (this.sortDirection == 'A' ? 'D' : (this.sortDirection == 'D' ? undefined : 'A'));
      }
      else
      {
        this.sortColumn = column.field;
        this.sortDirection = 'A';
      }
    }

    if (!this.sortDirection) {
      if (this.json) {
        this.item.data = JSON.parse(this.json);
      }
    }
    else {
      if (this.item.data) {
        const sc = this.sortColumn;
        let data = _.sortBy(this.item.data, function (r) { return r[sc]});
        if (this.sortDirection == 'D') data = data.reverse();
        this.item.data = data;
      }
    }
  }

  calcKpiValueClass(value: any): string {
    const len = value.toString().length;
    if (len <= 7) return "kpi-value-large";
    if (len <= 10) return "kpi-value-normal";
    return "kpi-value-small";
  }

  /*async create(formId: string) {
    await this.bffService.CreateDataEntry(this.organizationId, formId).then(deid => {
      this.notificationService.showNotification('Az adatszolgáltatás létrehozása sikerült!', Severity.success);
      this.router.navigate(['/dataentry/opened/render', deid]);    
    }).catch(e => {
      this.notificationService.showNotification(e.error, Severity.error);
    });
  } */
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/kpi/kpi.component.ts